import jwtDecode from 'jwt-decode';
import { tokenUtility } from '../token';
import resolveEnv, { PROD, resolveDomain, TITLESOLUTIONS } from '@fluentsms/utils';

export function getUserId() {
  const token = tokenUtility.getIdToken();
  const decodedToken: Record<string, { userId: string }> = jwtDecode(token ?? '');
  const env = resolveEnv() === PROD ? '' : `${resolveEnv().toLowerCase()}.`;
  const domain = resolveDomain() === TITLESOLUTIONS ? `fluentapi.${resolveDomain()}.com` : `api.${resolveDomain()}.com`;

  const userId = decodedToken[`https://${env}${domain}/users/auth`]?.userId ?? '';
  return userId;
}
